import { render, staticRenderFns } from "./AddJourneyParticipantsModal.vue?vue&type=template&id=8c36bbf0&scoped=true"
import script from "./AddJourneyParticipantsModal.vue?vue&type=script&lang=js"
export * from "./AddJourneyParticipantsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c36bbf0",
  null
  
)

export default component.exports